import {ForeignKey, Model} from "weed-js";
import {CanonicalOrganization} from "./canonical";


export class SSOModel extends Model {
    static namespace = "sso";

    static dal(client) {
        return client.sso.dal.v1();
    }

}

export class Organization extends SSOModel {
    static columns = ["id", "name", "created_by_id", "logo", "grandpa", "is_active", "address_id"]
    static pluralName = "organizations";

    static canonicalClasses = [CanonicalOrganization];
}

export class Facility extends SSOModel {

    static columns = [
        "id",
        "account_id",
        "organization_id",
        "license_number",
        "name",
    ];

    static uri = "/metrc-facilities/";
    static pluralName = "facilities";
}


export class Vertical extends SSOModel {

    static columns = [
        "id",
        "name",
        "description"
    ];

    static uri = "/verticals/";
    static pluralName = "verticals";

}

export class Category extends SSOModel {
    static columns = [
        "id",
        "name",
        "description",
    ];

    static uri = "/categories/";
    static pluralName = "categories";
}

export class View extends SSOModel {
    static columns = [
        "id", "integration", "organization_id", "created_by_id", "vertical_id",
        "category_id", "name", "description", "json"
    ]
    static uri = "/views/";
    static pluralName = "views";

    static foreignKeys = {
        organization: new ForeignKey(Organization),
        vertical: new ForeignKey(Vertical),
        category: new ForeignKey(Category),
    }

}
